
import React, { createContext, useContext } from 'react';
import { useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
const authContext = createContext();
export function ProvideAuth({ children }) {
  const [cookies] = useCookies(["user"]);
  const user = cookies;
  return (
    <authContext.Provider value={user}>
      {children}
    </authContext.Provider>
  );
}
export function useAuth() {
  return useContext(authContext);
}
export function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
